import * as React from 'react';

import UserOrbit56 from './UserOrbit56';

export const userOrbit56 = () => <UserOrbit56 />;

export default {
    title: 'Illustration|UserOrbit56',
    component: UserOrbit56,
    parameters: {
        notes: "`import UserOrbit56 from 'box-ui-elements/es/illustration/UserOrbit56';`",
    },
};
